import { Badge, BadgeText } from "@repo/components/src/ui/badge";
import { Box } from "@repo/components/src/ui/box";
import { SystemMessageProps } from "@kesha-antonov/react-native-chat";
import { MontuMessage } from "../../types";

export default function GiftedChatSystemMessage(
  props: SystemMessageProps<MontuMessage>,
) {
  if (!props.currentMessage.text) return null;
  return (
    <Box className="items-center justify-center mt-2 mb-3">
      <Badge size="lg" className="max-w-72">
        <BadgeText className="text-center">
          {props.currentMessage.text}
        </BadgeText>
      </Badge>
    </Box>
  );
}
